import React, { useState, useEffect, useCallback, useRef } from "react";
import "./Carousel.css";

function Carousel() {
  const images = [
    "/images/ana1.jpg",
    "/images/kimyasal_1.jpg",
    "/images/kimyasal_2.jpg",
    "/images/kimyasal_3.jpg",
    "/images/kimyasal_4.jpg",
    "/images/kimyasal_5.jpg",
    "/images/kimyasal_6.jpg",
    "/images/mikro1.jpg",
    "/images/mikro2.jpg",
    "/images/mikro3.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null); // Interval referansı

  // Otomatik geçişi başlat
  const startAutoSlide = useCallback(() => {
    clearInterval(intervalRef.current); // Önceki intervali temizle
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 7000); // 7 saniyelik geçiş süresi
  }, [images.length]);

  // Bir sonraki slayta geçiş
  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
    startAutoSlide(); // Süreyi sıfırla
  }, [images.length, startAutoSlide]);

  // Bir önceki slayta geçiş
  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
    startAutoSlide(); // Süreyi sıfırla
  };

  // Component yüklendiğinde otomatik geçişi başlat
  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(intervalRef.current); // Component kaldırıldığında intervali temizle
  }, [startAutoSlide]);

  return (
    <div className="carousel">
      {images.map((image, index) => (
        <div
          key={index}
          className={`carousel-slide ${
            index === currentIndex ? "active" : ""
          }`}
          style={{
            backgroundImage: `url(${image})`,
          }}
        ></div>
      ))}
      <button className="carousel-button prev" onClick={prevSlide}>
        ◀
      </button>
      <button className="carousel-button next" onClick={nextSlide}>
        ▶
      </button>
    </div>
  );
}

export default Carousel;
